<template>
  <div class="edit-selected">
    <van-nav-bar
      class="file-header nav-bar-bgcolor"
      :title="title"
      :left-text="$t('base.close')"
      :right-text="$t('base.save')"
      @click-left="handleClickLeft"
      @click-right="handleClickRight"
    />
    <contact-list
      :list="selectList"
      :entities="selectEntities"
      showDelete
      @add-delete-id="handleDelete"
      @scroll.passive="onSrcoll"
    />
  </div>
</template>
<script>
import ContactList from './ContactList'
import {i18n} from '@/utils/i18n'

export default {
  name: 'EditSelected',
  i18n,
  components: {
    ContactList
  },
  props: {
    selectListProps: Array,
    selectEntitiesProps: Object
  },
  data () {
    return {
      title: i18n.t('contact.selected'),
      selectList: this.selectListProps.sort((a, b) => {
        const itemA = this.selectEntitiesProps[a]
        const itemB = this.selectEntitiesProps[b]
        if ((itemB.is_department && !itemA.is_department) || (itemB.is_group && !itemA.is_group && !itemA.is_department)) {
          return 1
        } else {
          return -1
        }
      }),
      selectEntities: {...this.selectEntitiesProps},
      removeIds: []
    }
  },
  created () {
  },
  methods: {
    handleClickLeft () {
      this.$emit('toggle-edit-selected')
    },
    handleClickRight () {
      this.$emit('delete-selected', this.removeIds)
      this.$emit('toggle-edit-selected')
    },
    handleDelete (typedId, index) {
      this.selectList = [...this.selectList.slice(0, index), ...this.selectList.slice(index + 1)]
      this.removeIds = [...this.removeIds, typedId]
    }
  }
}
</script>
<style lang="postcss">
@import 'variables';

.edit-selected {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  & .delete {
    display: inline-block;
    box-sizing: border-box;
    width: 20px;
    height: 20px;
    line-height: 14px;
    border: 1px solid var(--contentIcon);
    border-radius: 50%;
    text-align: center;
    font-size: 40px;
    color: var(--contentIcon);
  }
}
</style>
